export enum FontSyncStatus {
  COMPLETED = "completed",
  PENDING = "pending",
  DELETED = "deleted",
}

export enum FontPickerSegment {
  ALL_FONTS = 0,
  FAVORITES = 1,
  UPLOADED = 2,
}

export interface UploadedFontModel {
  id: string; // UUID
  postScriptName: string;
  displayName: string;
  fileName: string;
  fileSize: number;
  dateAdded: number; // timestamp in seconds (TimeInterval matching iOS)
  format: "ttf" | string;
  status: FontSyncStatus | string;
  fileKey?: string;
  userId?: string;
  createdAt?: string;
  updatedAt?: string;
  downloadUrl?: string;
  blob?: Blob;
}

export interface FavoriteFontModel {
  id: string; // UUID
  fontName: string; // Unique identifier (postScriptName or system/premium font name)
  displayName: string;
  isCustom: boolean;
  fileName?: string;
  dateFavorited: number; // timestamp
}

export interface FontMetadata {
  fontFamily: string;
  subFamily?: string;
  fullName: string;
  postScriptName: string;
}

export interface RemoteFontsResponse {
  fonts: Array<{
    id: string;
    name: string;
    fileKey?: string;
    userId?: string;
    createdAt?: string;
    updatedAt?: string;
    downloadUrl?: string;
  }>;
  total: number;
  page?: number;
  limit?: number;
}
